import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {MaterialRealtimeChange} from "@project/sdk/realtime";

import {materialKeys} from "../material-keys";

type MaterialRealtimeChangeEvent = output<typeof MaterialRealtimeChange>;

export const materialsRealtimeHandler: ResourceChangeRealtimeHandler<MaterialRealtimeChangeEvent> =
  {
    resource: "engineering.materials",
    queryKey: materialKeys.all,
    eventSchema: MaterialRealtimeChange,
    async handleEvent(event, queryClient) {
      if (event.change === "CREATED") {
        await queryClient.invalidateQueries({queryKey: materialKeys.lists()});
        return;
      }
      await queryClient.invalidateQueries({queryKey: materialKeys.all});
    },
  };
